import s from './GridCellBorder.module.css';

function GridCellBorder() {
  return (
    <div data-test-id="selected-cell-border" className={s.cellSelectedBorder} />
  );
}

export default GridCellBorder;
